import React from 'react';
import { Stack, Box } from '@mui/material';
import DownloadInteraction from './download-interaction';
import DeleteInteraction from './delete-interaction';
import ShareInteraction from './share-interaction';

interface Props {
  metadata: Record<string, any>;
  handleDeleteClick: () => void;
  handleShareClick: () => void;
}
const MediaInteractions: React.FC<Props> = ({ metadata, handleDeleteClick, handleShareClick }) => {
  const dataReady = metadata ?? undefined;

  return (
    <Stack sx={{ width: '324px' }} direction="column" justifyContent="space-between" alignItems="start">
      <Stack sx={{ width: '100%' }} direction="row" justifyContent="end" alignItems="center">
        { dataReady && (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              width: '35%',
            }}
          >
            <ShareInteraction handleShareClick={handleShareClick} />
            <DownloadInteraction metadata={metadata} />
            <DeleteInteraction handleDeleteClick={handleDeleteClick} />
          </Box>
        )}
      </Stack>
    </Stack>
  );
};

export default MediaInteractions;
